enum Access {
  None = 0,
  Open = 1,
  Restricted = 2,
}

export default Access;
